module.exports = __webpack_public_path__ + "img/community-foundation-logo.482bda18.jpg";